import { createNavigation } from 'next-intl/navigation'
import { locales, defaultLocale } from './config'

// ============================================================================
// Локализованная навигация next-intl.
// localePrefix: 'always' — ВСЕ URL несут префикс локали, включая дефолтную
// (/ru/..., /ro/..., /en/...). Любой путь без префикса middleware (proxy.ts)
// редиректит на префиксованный (по cookie/Accept-Language). Так локаль никогда
// не теряется при редиректах (логин, /dashboard и т.п.).
//
// Используйте эти Link/redirect/useRouter ВМЕСТО next/link и next/navigation
// для внутренних ссылок — они сами проставят правильный префикс локали.
// ============================================================================
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation({
    locales,
    defaultLocale,
    localePrefix: 'always',
  })
